<template>
    <div class="monitoring-plan-card"
         :class="{'disabled': disabled}">
        <true-panel>
            <div class="mpc-title-row">
                <div class="mpc-title">
                    <div v-if="type == 'pulse'"> ADT Pulse level {{ level }}</div>
                    <div v-if="type == 'cellular'"> Cellular</div>
                    <div v-if="type == 'landline'"> Landline</div>
                    <div class="mpc-description">{{ description }}</div>
                </div>
                <div class="mpc-price">
                    <div class="dollars">
                        ${{ dollars }}<span class="cents">.{{ cents }}</span>
                    </div>
                    <div class="mpc-price-frequency">per month</div>
                </div>
            </div>
            <div class="mpc-features">
                
                <div class="mpc-feature"
                     :class="{ 'selected': activeFeatures.includes('monitoring247') }"
                     @click="showModal('monitoring247')">
                    <div class="mpc-feature-icon">
                        <img src="/img/monitoring-icons/24-hours-selected.png"
                             alt=""
                             v-if="activeFeatures.includes('monitoring247')">
                        <img src="/img/monitoring-icons/24-hours.png"
                             alt=""
                             v-if="!activeFeatures.includes('monitoring247')">
                    </div>
                    <div class="mpc-feature-title">24/7 live monitoring</div>
                </div>

                <div class="mpc-feature"
                     :class="{ 'selected': activeFeatures.includes('cellularConnection') }"
                     @click="showModal('cellularConnection')">
                    <div class="mpc-feature-icon">
                        <img src="/img/monitoring-icons/cell-connection-selected.png"
                             alt=""
                             v-if="activeFeatures.includes('cellularConnection')">
                        <img src="/img/monitoring-icons/cell-connection.png"
                             alt=""
                             v-if="!activeFeatures.includes('cellularConnection')">
                    </div>
                    <div class="mpc-feature-title">Cellular connection</div>
                </div>

                <!-- FEATURE -->
                <div class="mpc-feature"
                     :class="{ 'selected': activeFeatures.includes('smartphoneControl') }"
                     @click="showModal('smartphoneControl')">
                    <div class="mpc-feature-icon">
                        <img src="/img/monitoring-icons/smartphone-control-selected.png"
                             alt=""
                             v-if="activeFeatures.includes('smartphoneControl')">
                        <img src="/img/monitoring-icons/smartphone-control.png"
                             alt=""
                             v-if="!activeFeatures.includes('smartphoneControl')">
                    </div>
                    <div class="mpc-feature-title">Smartphone control</div>
                </div>
                <!-- END FEATURE -->

                <!-- FEATURE -->
                <div class="mpc-feature"
                     :class="{ 'selected': activeFeatures.includes('twoWayCalling') }"
                     @click="showModal('twoWayCalling')">
                    <div class="mpc-feature-icon">
                        <img src="/img/monitoring-icons/two-way.png"
                             alt=""
                             v-if="!activeFeatures.includes('twoWayCalling')">
                        <img src="/img/monitoring-icons/two-way-selected.png"
                             v-if="activeFeatures.includes('twoWayCalling')"
                             alt="">
                    </div>
                    <div class="mpc-feature-title">Two-way voice</div>
                </div>
                <!-- END FEATURE -->

                <!-- FEATURE -->
                <div class="mpc-feature"
                     :class="{'selected': activeFeatures.includes('videosAndCameras') }"
                     @click="showModal('videosAndCameras')">
                    <div class="mpc-feature-icon">
                        <img src="/img/monitoring-icons/video-cameras.png"
                             alt=""
                             v-if="!activeFeatures.includes('videosAndCameras')">
                        <img src="/img/monitoring-icons/video-cameras-selected.png"
                             alt=""
                             v-if="activeFeatures.includes('videosAndCameras')">
                    </div>
                    <div class="mpc-feature-title">Videos &amp; cameras</div>
                </div>
                <!-- FEATURE -->
                <div class="mpc-feature"
                     :class="{'selected': activeFeatures.includes('homeControl') }"
                     @click="showModal('homeControl')">
                    <div class="mpc-feature-icon">
                        <img src="/img/monitoring-icons/home-control.png"
                             alt=""
                             v-if="!activeFeatures.includes('homeControl')">
                        <img src="/img/monitoring-icons/home-control-selected.png"
                             alt=""
                             v-if="activeFeatures.includes('homeControl')">
                    </div>
                    <div class="mpc-feature-title">Home <br> control</div>
                </div>
                <!-- END FEATURE -->
            </div>
            <div class="mpc-action"
                 v-if="hasSelectButton">
                <button class="switch-plan-button"
                        @click="select(id, type)">
                    <span v-if="!isLandline">Switch to this plan</span>
                    <span v-if="isLandline && hasLandline">Switch to this plan</span>
                    <span v-if="isLandline && !hasLandline">This requires a landline</span>
                </button>
            </div>
        </true-panel>

        <!-- MODAL -->
        <div class="modal" v-show="modals.monitoring247">
            <div class="modal-content">
                <div class="pageCompleted">Monitoring Explained</div>
                <div class="pageTitle">24/7 Live Monitoring</div>
                <p>
                    Means your system is always monitored. 7 monitoring stations are ready to respond to anything.
                </p>
                <button class="button" type="button" @click="closeModal('monitoring247')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

        <!-- MODAL -->
        <div class="modal" v-show="modals.cellularConnection">
            <div class="modal-content">
                <div class="pageCompleted">Monitoring Explained</div>
                <div class="pageTitle">Cellular connection</div>
                <p>
                No Phone Line Required. Your system is connected directly to our monitoring station using a GSM radio. No need to worry about cut phone lines or no internet connection stopping your alarm from communicating with ADT.
                </p>
                <button class="button" type="button" @click="closeModal('cellularConnection')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

         <!-- MODAL -->
        <div class="modal" v-show="modals.smartphoneControl">
            <div class="modal-content">
                <div class="pageCompleted">Monitoring Explained</div>
                <div class="pageTitle">Smartphone control</div>
                <p>
                    Access and control your system using your smartphone. Also receive real time notifications.
                </p>
                <button class="button" type="button" @click="closeModal('smartphoneControl')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

         <!-- MODAL -->
        <div class="modal" v-show="modals.twoWayCalling">
            <div class="modal-content">
                <div class="pageCompleted">Monitoring Explained</div>
                <div class="pageTitle">Two way voice</div>
                <p>
                    Communicate directly with our monitoring station through the control panel. Allows dispatch to prioritize your signal.
                </p>
                <button class="button" type="button" @click="closeModal('twoWayCalling')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

         <!-- MODAL -->
        <div class="modal" v-show="modals.videosAndCameras">
            <div class="modal-content">
                <div class="pageCompleted">Monitoring Explained</div>
                <div class="pageTitle">Videos &amp;  cameras</div>
                <p>
                    View video recorded from your cameras and smart phone.
                </p>
                <button class="button" type="button" @click="closeModal('videosAndCameras')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

         <!-- MODAL -->
        <div class="modal" v-show="modals.homeControl">
            <div class="modal-content">
                <div class="pageCompleted">Monitoring Explained</div>
                <div class="pageTitle">Home control</div>
                <p>
                    Control lights and set timers using your smart phone.
                </p>
                <button class="button" type="button" @click="closeModal('homeControl')">Ok, thanks</button>
            </div>
        </div>
        <!-- END MODAL -->

    </div>
</template>




<script>
import { mapActions, mapState } from "vuex";
export default {
  props: [
    "id",
    "type",
    "selected",
    "level",
    "price",
    "description",
    "features"
  ],
  data: () => ({
    modals: {
      monitoring247: false,
      cellularConnection: false,
      smartphoneControl: false,
      twoWayCalling: false,
      videosAndCameras: false,
      homeControl: false
    }
  }),
  computed: {
    ...mapState(["lead"]),

    activeFeatures() {
      // Landline card but doesn't have a land line
      if (!this.hasLandline && this.isLandline) {
        return [];
      }

      // If landline
      if (!this.features && this.isLandline) {
        return ["monitoring247"];
      }

      // If cellular
      if (!this.features && this.type === "cellular") {
        return ["monitoring247", "cellularConnection", "twoWayCalling"];
      }

      if (!this.features && this.type === "pulse") {
        let features = [
          "monitoring247",
          "cellularConnection",
          "twoWayCalling",
          "smartphoneControl"
        ];
      }

      if (!this.features) {
        return [
          "monitoring247",
          "cellularConnection",
          "smartphoneControl",
          "twoWayCalling",
          "videosAndCameras",
          "homeControl"
        ];
      }

      return this.features;
    },

    // Get the dollar amount in price
    dollars() {
      return this.price.split(".")[0];
    },

    // Get the cents amount in price
    cents() {
      return this.price.split(".")[1];
    },

    hasSelectButton() {
      return this.type !== "pulse" && this.selected === false;
    },

    disabled() {
      if (this.isLandline && !this.hasLandline) {
        return true;
      }
      return false;
    },

    hasLandline() {
      return this.lead.phoneService == "Traditional Land Line";
    },

    isLandline() {
      return this.type == "landline";
    }
  },
  methods: {
    ...mapActions(["selectMonitoringPlan", "save"]),

    select(id, type) {
      if (this.isLandline && !this.hasLandline) {
        return;
      }
      this.selectMonitoringPlan(id).then(() => {
        this.save();
      });
    },

    showModal(name) {
      this.modals[name] = true;

      let features = {
        monitoring247: "24/7 live monitoring",
        cellularConnection: "Cellular connection",
        smartphoneControl: "Smartphone control",
        twoWayCalling: "Two-way calling",
        videosAndCameras: "Videos & camera",
        homeControl: "Home Control"
      };

      mixpanel.track("inspectedMonitoringFeature", {
        monitoringFeature: features[name]
      });
    },

    closeModal(name) {
      this.modals[name] = false;
    }
  }
};
</script>

<style lang="css"></style>
